<ion-content>
  <div class="page-wrapper">

    <div class="page-header">
      <a class="back-link" (click)="backToList()">← {{ 'tokenDetail.backToList' | translate }}</a>
    </div>

    @if (isLoading) {
    <div class="center-row"><ion-spinner></ion-spinner></div>
    } @else if (loadError || !token) {
    <div class="center-row">
      <p>{{ 'tokenDetail.loadError' | translate }}</p>
      <ion-button fill="outline" size="small" (click)="load()">{{ 'common.retry' | translate }}</ion-button>
    </div>
    } @else {

    <ion-card class="token-card" [class.token-card--revoked]="isRevoked()">
      <ion-card-content>
        <div class="token-card__head">
          <div>
            <h1>{{ token.name }}</h1>
            <code class="token-card__prefix">
              {{ token.tokenPrefix }}…
              <ion-button size="small" fill="clear" (click)="copyPrefix(token.tokenPrefix)">
                <ion-icon name="copy-outline" slot="icon-only"></ion-icon>
              </ion-button>
            </code>
          </div>
          @if (isRevoked()) {
          <ion-badge color="medium">{{ 'tokens.card.revokedBadge' | translate }}</ion-badge>
          } @else if (isExpired()) {
          <ion-badge color="warning">{{ 'tokens.card.expiredBadge' | translate }}</ion-badge>
          } @else {
          <ion-button size="small" fill="clear" color="danger" (click)="revoke()">
            <ion-icon name="trash-outline" slot="start"></ion-icon>
            {{ 'tokens.card.revokeAction' | translate }}
          </ion-button>
          }
        </div>

        <div class="token-card__scopes">
          @for (scope of token.scopes; track scope.feature) {
          <ion-badge [color]="levelColor(scope.level)">{{ scope.feature }}: {{ scope.level }}</ion-badge>
          }
        </div>

        <div class="token-card__meta">
          <span>{{ 'tokens.card.created' | translate:{ date: (token.createdAt | date:'short') } }}</span>
          <span>{{ 'tokens.card.lastUsed' | translate:{ date: token.lastUsedAt ? (token.lastUsedAt | date:'short') : ('tokens.card.never' | translate) } }}</span>
          @if (token.expiresAt) {
          <span>{{ 'tokens.card.expiresAt' | translate:{ date: (token.expiresAt | date:'short') } }}</span>
          }
        </div>
      </ion-card-content>
    </ion-card>

    <div class="section-title">{{ 'tokenDetail.usageTitle' | translate }}</div>
    <ion-card class="usage-card">
      <ion-card-content>
        @if (usage.length === 0) {
        <div class="center-row"><p>{{ 'tokenDetail.usageEmpty' | translate }}</p></div>
        } @else {
        <div class="usage-table">
          <div class="usage-table__row usage-table__row--head">
            <span>{{ 'tokenDetail.usage.method' | translate }}</span>
            <span>{{ 'tokenDetail.usage.path' | translate }}</span>
            <span>{{ 'tokenDetail.usage.status' | translate }}</span>
            <span>{{ 'tokenDetail.usage.timestamp' | translate }}</span>
          </div>
          @for (entry of usage; track entry.occurredAt + entry.path) {
          <div class="usage-table__row">
            <span class="method-badge" [ngClass]="methodBadgeClass(entry.method)">{{ entry.method }}</span>
            <code class="usage-table__path">{{ entry.path }}</code>
            <ion-badge [color]="statusColor(entry.statusCode)">{{ entry.statusCode }}</ion-badge>
            <span class="usage-table__time">{{ entry.occurredAt | date:'short' }}</span>
          </div>
          }
        </div>
        }
      </ion-card-content>
    </ion-card>
    }
  </div>
</ion-content>
